<!-- <app-main-navbar></app-main-navbar> -->

<router-outlet></router-outlet>

<app-chat-widget *ngIf="showChatWidget"></app-chat-widget>
